import { axiosGet } from "../../Helpers";

export const loadInterests = async (setLoading) => {
  setLoading(true);
  const response = await axiosGet("interest/listInterest");
  setLoading(false);
  const data = response.data?.data;
  data.map((item, index) => {
    item.id = index + 1;
  });
  return data;
};
